import * as ActionTypes from '../Join';
import { CALL_API } from '../../../middleware/api';
export function fetchJoin(data) {
    var _a;
    if (!data.JoinData.Promo) {
        data.JoinData.Promo = null;
    }
    return _a = {
            type: ActionTypes.JOIN
        },
        _a[CALL_API] = {
            endpoint: '/registration/join',
            method: 'post',
            types: [ActionTypes.SUCCESS_JOIN, ActionTypes.FAILURE_JOIN],
            credentials: true,
            data: data
        },
        _a;
}
export function changeJoinType(data) {
    return function (dispatch) {
        dispatch({
            type: ActionTypes.CHANGE_JOIN_TYPE,
            data: data
        });
    };
}
export function openRegistrationModal() {
    return {
        type: ActionTypes.OPEN_REGISTRATION_MODAL
    };
}
export function closeRegistrationModal() {
    return {
        type: ActionTypes.CLOSE_REGISTRATION_MODAL
    };
}
export function confirmJoin(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.CONFIRM_JOIN
            },
            _a[CALL_API] = {
                endpoint: "/registration/confirm",
                method: 'post',
                types: [
                    ActionTypes.SUCCESS_CONFIRM_JOIN,
                    ActionTypes.FAILURE_CONFIRM_JOIN
                ],
                data: data
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/auth/creators/Join.js